// Fragment "admin reschedule" — RescheduleDialog.jsx, plus the "Reschedule" row
// action it is opened from (BookingsAdmin.jsx, admin/booking/EventDetailDialog.jsx).
// Error keys mirror the 409 refusal codes POST /admin/bookings/{id}/reschedule can
// answer with (modules/booking/schemas.py AdminRescheduleRequest). Merged in ./index.js.
export default {
  fr: {
    "bookings.reschedule": "Déplacer",
    "reschedule.title": "Déplacer le rendez-vous",
    "reschedule.subtitle": "Choisissez un nouveau moment pour « {service} ».",
    "reschedule.noSlots": "Aucun horaire libre à venir pour ce service.",
    "reschedule.submit": "Déplacer",
    "reschedule.close": "Annuler",
    "reschedule.success": "Rendez-vous déplacé.",
    "reschedule.err.conflict": "Ce créneau vient d'être pris. Choisissez-en un autre.",
    "reschedule.err.deliveryMismatch": "Ce créneau n'est pas dans le même mode : un rendez-vous en visio ne peut pas devenir une séance au cabinet, ni l'inverse. Annulez et reprenez la réservation.",
    "reschedule.err.bookingCancelled": "Ce rendez-vous est annulé : il n'y a plus rien à déplacer.",
    "reschedule.err.bookingCompleted": "Ce rendez-vous a déjà eu lieu.",
    "reschedule.err.paymentPending": "Un paiement est en cours pour ce rendez-vous — attendez qu'il aboutisse avant de le déplacer.",
    "reschedule.err.paymentRefunded": "Ce rendez-vous a été remboursé : le déplacer reviendrait à garder une place pour une personne déjà remboursée.",
  },
  en: {
    "bookings.reschedule": "Reschedule",
    "reschedule.title": "Reschedule appointment",
    "reschedule.subtitle": "Choose a new time for “{service}”.",
    "reschedule.noSlots": "No upcoming time is free for this service.",
    "reschedule.submit": "Reschedule",
    "reschedule.close": "Cancel",
    "reschedule.success": "Appointment rescheduled.",
    "reschedule.err.conflict": "That time was just taken. Choose another.",
    "reschedule.err.deliveryMismatch": "That time is not in the same mode: a video consultation cannot become an in-practice session, or the other way round. Cancel and rebook instead.",
    "reschedule.err.bookingCancelled": "This appointment is cancelled — there is nothing left to move.",
    "reschedule.err.bookingCompleted": "This appointment has already taken place.",
    "reschedule.err.paymentPending": "A payment is in flight for this appointment — wait for it to settle before moving it.",
    "reschedule.err.paymentRefunded": "This appointment was refunded: moving it would hold a seat for someone who has been paid back.",
  },
  es: {
    "bookings.reschedule": "Reprogramar",
    "reschedule.title": "Reprogramar la cita",
    "reschedule.subtitle": "Elija un nuevo horario para «{service}».",
    "reschedule.noSlots": "No hay próximos horarios libres para este servicio.",
    "reschedule.submit": "Reprogramar",
    "reschedule.close": "Cancelar",
    "reschedule.success": "Cita reprogramada.",
    "reschedule.err.conflict": "Ese horario acaba de ser reservado. Elija otro.",
    "reschedule.err.deliveryMismatch": "Ese horario no es de la misma modalidad: una consulta por vídeo no puede convertirse en una sesión presencial, ni al contrario. Cancele y reserve de nuevo.",
    "reschedule.err.bookingCancelled": "Esta cita está cancelada — no queda nada que mover.",
    "reschedule.err.bookingCompleted": "Esta cita ya tuvo lugar.",
    "reschedule.err.paymentPending": "Hay un pago en curso para esta cita — espere a que se complete antes de moverla.",
    "reschedule.err.paymentRefunded": "Esta cita fue reembolsada: moverla supondría reservar un lugar para alguien a quien ya se le devolvió el dinero.",
  },
};
